<!-- Especificação Padrão do cliente: aviso que não pode passar despercebido. O html já vem filtrado
     para as tags do editor (ver o .ts). -->
<section *ngIf="destacar && html" class="espec" role="note" aria-label="Especificação padrão do cliente">
    <div class="espec-cabecalho">
        <span class="espec-icone"><i class='bx bx-error'></i></span>
        <div class="espec-titulos">
            <span class="espec-titulo">Especificação padrão do cliente</span>
            <span class="espec-subtitulo">
                {{ cliente ? 'Vale para todos os pedidos de ' + cliente : 'Vale para todos os pedidos deste cliente' }}
            </span>
        </div>
        <span class="espec-selo"><i class='bx bx-pin'></i>Atenção</span>
    </div>
    <div class="especificacao-destaque espec-conteudo" [innerHTML]="html"></div>
</section>
